import Helpers from '@Apis/helpers';
import Constants, { stage } from '@Apis/constants';

class ForecastServices {
  // purchase
    /**
     *
     * @param startDate
     * @param endDate
     * @param tenantIds
     * @returns {Promise<*>}
     */
    createForecast = async (formData) => {
      const url = `${Constants.FORECASTING}/demand_forecasting/save_processed_data`;
      const data = new FormData();
      data.append('validation_data_percentage', formData?.validationData);
      data.append('forecast_duration_in_days', formData?.durationUnit === 'Weeks' ? Number(formData?.durationNumber) * 7 : Number(formData?.durationNumber) * 30);
      data.append('file', formData?.file);
      data.append('forecast_name', formData?.forecastName);
      data.append('tenant_id', formData?.tenantId);
      data.append('org_id', formData?.orgId);
      data.append('target', formData?.target);
      data.append('stage', stage);
      data.append('null_check', formData?.nullValues);
      const response = await Helpers.filePost({
        url,
        file: data,
      });
      return response;
    }

    /**
     *
     * @param payload
     * @returns {Promise<*>}
     */
    startForecast = async (payload) => {
      const url = `${Constants.FORECASTING}/demand_forecasting/train_and_save_models`;
      const response = await Helpers.post({
        url,
        data: {
          ...payload,
          stage,
        },
      });
      return response;
    }

    /**
     *
     * @returns {Promise<*>}
     */
    getForecasts = async (status, orgId, page, limit, searchKeyword) => {
      let url = `${Constants.FORECASTING}/demand_forecasting/get_processed_data_list?`;
      if (status) url += `status=${status}&`;
      if (orgId) url += `org_id=${orgId}&`;
      if (page) url += `page=${page}&`;
      if (limit) url += `limit=${limit}&`;
      if (searchKeyword) url += `search_keyword=${searchKeyword}&`;
      url += `stage=${stage}&`;
      const response = await Helpers.get({
        url,
      });
      return response;
    }

    /**
     *
     * @param forecastId
     * @returns {Promise<*>}
     */
    getForecastById = async (forecastId) => {
      const url = `${Constants.FORECASTING}/demand_forecasting/get_processed_data_by_id?forecast_id=${forecastId}&stage=${stage}`;
      const response = await Helpers.get({
        url,
      });
      return response;
    }

    /**
     *
     * @param forecastId
     * @param modelName
     * @param store
     * @param item
     * @returns {Promise<*>}
     */
    getForecastResults = async (forecastId, modelName, store, item, channel) => {
      let url = `${Constants.FORECASTING}/demand_forecasting/get_forecasted_data?stage=${stage}&forecast_id=${forecastId}&`;
      if (modelName) url += `model_name=${modelName}&`;
      if (store) url += `store=${store}&`;
      if (item) url += `item=${item}&`;
      if (channel) url += `channel=${channel}&`;
      const response = await Helpers.get({
        url,
      });
      return response;
    }

    /**
     *
     * @param forecastId
     * @param modelName
     * @param store
     * @param item
     * @param channel
     * @returns {Promise<*>}
     */
    downloadForecast = async (forecastId, modelName, store, item, channel) => {
      let url = `${Constants.FORECASTING}/demand_forecasting/download_forecasted_data?stage=${stage}&forecast_id=${forecastId}&`;
      if (modelName) url += `model_name=${modelName}&`;
      if (store) url += `store=${store}&`;
      if (item) url += `item=${item}&`;
      if (channel) url += `channel=${channel}&`;
      const response = await Helpers.getFile({
        url,
      });
      return response;
    }
}
export default new ForecastServices();
